module.exports = __webpack_public_path__ + "assets/img/landing-hero.f7a4de3b.webp";